import { useTranslation } from 'react-i18next';
import { setUserLanguage } from '@/utils/userLanguage';
import styles from './styles.module.scss';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const toggleLanguage = () => {
    const newLang = currentLang === 'ru' ? 'en' : 'ru';
    i18n.changeLanguage(newLang);
    setUserLanguage(newLang);
  };

  return (
    <button
      className={styles.switcher}
      onClick={toggleLanguage}
      aria-label="Switch language"
    >
      <span className={currentLang === 'en' ? styles.active : ''}>EN</span>
      <span className={styles.divider}>/</span>
      <span className={currentLang === 'ru' ? styles.active : ''}>RU</span>
    </button>
  );
};

export default LanguageSwitcher;
